var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18182 0H10.3636C11.2674 0 12 0.732625 12 1.63636V3.81818C12 4.72192 11.2674 5.45455 10.3636 5.45455H8.18182C7.27808 5.45455 6.54545 4.72192 6.54545 3.81818V1.63636C6.54545 0.732625 7.27808 0 8.18182 0Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63636 0H3.81818C4.72192 0 5.45455 0.732625 5.45455 1.63636V3.81818C5.45455 4.72192 4.72192 5.45455 3.81818 5.45455H1.63636C0.732625 5.45455 0 4.72192 0 3.81818V1.63636C0 0.732625 0.732625 0 1.63636 0Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18182 6.54545H10.3636C11.2674 6.54545 12 7.27808 12 8.18182V10.3636C12 11.2674 11.2674 12 10.3636 12H8.18182C7.27808 12 6.54545 11.2674 6.54545 10.3636V8.18182C6.54545 7.27808 7.27808 6.54545 8.18182 6.54545Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63636 6.54545H3.81818C4.72192 6.54545 5.45455 7.27808 5.45455 8.18182V10.3636C5.45455 11.2674 4.72192 12 3.81818 12H1.63636C0.732625 12 0 11.2674 0 10.3636V8.18182C0 7.27808 0.732625 6.54545 1.63636 6.54545Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/GridIcon.6261e58c3cdf677f57b29b9e8f876edf.svg";
export { ForwardRef as ReactComponent };